import React, { useState } from "react";
import PrimaryButton from "../buttons/PrimaryButton.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import Space from "../layout/Space.js";
import { useEffect } from "react";
import {
  createDoc,
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getFlutterTime,
  getFlutterTimeFromSeconds,
  getRefFromId,
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions.js";

import CheckBoxGrey from "../textfields/CheckBoxGrey.js";

import moment from "moment";
import SmallSpinner from "../loading/SmallSpinner.js";
import modifThermal from "../api/folder/modifThermal.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import TextField2 from "../textfields/TextField2.js";
import TextFieldEmail from "../textfields/TextFieldEmail.js";
import { useAppContext } from "../config/AppContext.js";
import { useSnackbar } from "notistack";
import { Timestamp } from "firebase/firestore";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import createDocApi from "../api/database/createDocApi.js";
import DropDownGPT1 from "../dropdowns/DropDownGPT1.js";
import MLTFGPT1 from "../textfields/MLTFGPT1.js";
import DropDownGPTMulti from "../dropdowns/DropDownGPTMulti.js";
import { addActivityLog } from "../config/OnlineStatus.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import DropDownGPTM3 from "../dropdowns/DropDownGPTM3.js";
import { getOrgById } from "../models/OrgFunctions.js";
import updateDocApi from "../api/database/updateDocApi.js";
import refreshCounters from "../api/refreshCounters.js";

const ModifThermique = ({
  document,
  folder,
  orgData,
  userData,
  onClose,
  onUpdate,
  onOpenEmailModal,
}) => {
  const [loadingData = false, setLoadingData] = useState(false);

  async function addVariables(content) {
    const client = await getOrgById(folder.client_id);
    const variables = {
      "@nom": folder.nom,
      "@ville": folder.ville,
      "@client": folder.marque || client.name,
    };
    let newContent = content;
    for (const [key, value] of Object.entries(variables)) {
      newContent = newContent.replace(key, value);
    }
    return newContent;
  }
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const handleModifThermal = async () => {
    setLoadingData(true);
    if (!type_selected) {
      handleClickVariant("Veuillez choisir un type de mise à jour", "error");
      setLoadingData(false);

      return;
    }

    const token = await getOrRefreshFirebaseToken();
    let modif_thermal = folder.modif_thermal;
    modif_thermal["activated"] = true;
    await updateDocDataFieldApi(
      folder.ref,
      "modif_thermal",
      modif_thermal,
      prefix
    );

    await addActivityLog(
      "Mise à jour de l'étude thermique initiée",
      folder.ref,
      orgData.id,
      userData.id,
      "maj_started",
      prefix
    );

    await updateDocDataFieldApi(
      folder.ref,
      "modif_thermal",
      {
        activated: true,
        users_id: users_selected || [],
        viewers_id: folder.thermal.viewers_id || [],
        datelastupdate: getFlutterTime(),
        indication: null,
        type: type_selected,
        files: [],
        state: "locked",
        xml: {
          state: "locked",
          file: null,
        },
      },

      prefix
    );

    await refreshCounters(token, folder.id, prefix);

    // await modifThermal(
    //   orgData.id,
    //   token,
    //   folder.id,
    //   object,
    //   content,
    //   users_selected || [],
    //   type_selected,
    //   prefix
    // );
    handleClickVariant("Mise à jour de l'étude thermique initiée", "success");
    setLoadingData(false);

    onClose();
    onOpenEmailModal();
  };
  const [all_email_templates, setAllEmailTemplates] = useState([]);
  const [email_templates_options, setEmailTemplatesOptions] = useState([]);
  const [email_template_selected, setEmailTemplateSelected] = useState(null);

  const [users_options, setUsersOptions] = useState([]);
  const [users_selected, setUsersSelected] = useState([]);

  const [type_selected, setTypeSelected] = useState(null);
  const [type_options, setTypeOptions] = useState([
    { value: "Mise à jour équipement", label: "Mise à jour équipement" },
    { value: "Mise à jour Q4", label: "Mise à jour Q4" },
    { value: "Mise à jour ventilation", label: "Mise à jour ventilation" },
  ]);
  const [all_receivers, setAllReceivers] = useState([]);
  const [receiver_options, setReceiverOptions] = useState([]);
  useEffect(() => {
    handleFetchData();
  }, [orgData]);

  const handleFetchData = async () => {
    let email_templates = [];

    const email_filters = [
      {
        field: "org_id",
        operator: "==",
        value: orgData.id,
      },
    ];
    email_templates = await queryCollection("email_template", email_filters);

    const users_filters = [
      {
        field: "org_id",
        operator: "==",
        value: folder.master_id,
      },
    ];
    let users = await queryCollection("user", users_filters);
    setUsersOptions(
      users.map((user) => {
        return {
          value: user.id,
          label: user.display_name,
        };
      })
    );

    setAllEmailTemplates(email_templates);
    setEmailTemplatesOptions(
      email_templates.map((template) => {
        return {
          value: template.id,
          label: template.name,
        };
      })
    );

    let partners = [];
    if (folder.partners_id) {
      partners = await getArrayDocDataByID("org", folder.partners_id);
    }
    let receivers = [];

    receivers = partners;

    setAllReceivers(receivers);
    setReceiverOptions(
      receivers.map((receiver) => {
        return {
          value: receiver.id,
          label: receiver.name,
        };
      })
    );
  };

  return (
    <div className="flex flex-col bg-white rounded-3xl w-c400">
      <div className=" text-h3 flex flex-row justify-between p-4 border-b-1">
        Demande de mise à jour thermique
        <div className="flex text-shadow_50 cursor-pointer" onClick={onClose}>
          Fermer
        </div>
      </div>

      <div className="flex flex-col p-4 bg-neutral-50">
        <div className=" text-h3 text-shadow_50">
          Retouchez l'email pour l'envoyer à votre bureau d'étude pour qu'il
          mette à jour l'étude thermique.
        </div>
        <Space y={10} />
        <DropDownGPTM3
          label="Choisir un ou plusieurs membres"
          items={users_options}
          onChange={(e) => {
            setUsersSelected(e);
          }}
          value={users_selected}
          mandatory={true}
        ></DropDownGPTM3>
        <Space y={10} />
        <DropDownGPT03
          label="Choisir un type de mise à jour"
          items={type_options}
          onChange={(e) => setTypeSelected(e.value)}
          value={type_selected}
          mandatory={true}
          className={"bg-white"}
        ></DropDownGPT03>
        <Space y={15} />
        <div className="text-h3 text-shadow_50 ">
          Vous serez redirigé vers la fenêtre de rédaction d'email juste après
          avoir cliqué sur le bouton "Initier la mise à jour"
        </div>
      </div>
      <div className="flex flex-row gap-2 justify-end border-t-1 p-4">
        <PrimaryButton
          className={"w-fit"}
          onClick={handleModifThermal}
          disabled={loadingData || !type_selected || !users_selected}
        >
          Initier la mise à jour <SmallSpinner loading={loadingData} />
        </PrimaryButton>
      </div>
    </div>
  );
};

export default ModifThermique;
